const DIRECTIVE_NAME = MightyDatepicker.DIRECTIVE_NAME = 'ktMightyDatepicker';
export default function MightyDatepicker(
    $parse
) {
    'ngInject';

    return {
        restrict: 'A',
        require: ['mightyDatepicker'],
        link: function($scope, $elem, $attrs, [mightyDatepickerCtrl]) {
            initializeOnSelectListener();
            initializeIsOpenedWatcher();

            function initializeOnSelectListener() {
                const onSelectListener = getAttributeValue('OnSelect');
                if (!onSelectListener) {
                    return;
                }
                function onSelect(date, isUserAction) {
                    if (isUserAction) {
                        $scope.$eval(onSelectListener);
                    }
                }
                mightyDatepickerCtrl.addOnSelectHandler(onSelect);
            }

            function initializeIsOpenedWatcher() {
                $scope.$watch(() => getParameter('IsOpened'), (isOpened) => {
                    if (!isOpened) {
                        return;
                    }
                    mightyDatepickerCtrl.setVisibility(isOpened);
                    setParameter('IsOpened', false);
                });
            }

            function getParameter(attribute) {
                return $scope.$eval($attrs[`${DIRECTIVE_NAME}${attribute}`]);
            }

            function setParameter(attribute, value) {
                return $parse($attrs[`${DIRECTIVE_NAME}${attribute}`]).assign($scope, value);
            }

            function getAttributeValue(attribute) {
                return $attrs[`${DIRECTIVE_NAME}${attribute}`];
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/mighty-datepicker-directive.js